export default class AppUser {
    constructor(
        public readonly appUserId: string,
        public readonly accountId: string,
        public readonly vtAppUserId: string,
        public readonly email: string,
        public readonly firstName: string,
        public readonly lastName: string,
        public readonly contactPhone: string,
        public readonly jobTitle: string,
        public readonly vtAppRole: string,
        public readonly createdAt: string,
        public readonly updatedAt: string
    ) { }

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }
}
